var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdeffectiveness(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.68,
    height: 27.705,
    viewBox: "0 0 27.68 27.705",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.054 -1.998)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.054 1.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.77,9.385a1.385,1.385,0,1,0-1.385,1.385A1.385,1.385,0,0,0,25.77,9.385Zm-1.385.462a.462.462,0,1,1,.462-.462A.462.462,0,0,1,24.385,9.847Z",
    transform: "translate(-13.328 -5.229)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31,15.385A1.385,1.385,0,1,0,32.385,14,1.385,1.385,0,0,0,31,15.385Zm1.385-.462a.462.462,0,1,1-.462.462A.462.462,0,0,1,32.385,14.923Z",
    transform: "translate(-17.634 -8.458)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.438,7.048a.462.462,0,0,0-.62.207L26.048,12.8a.462.462,0,1,0,.827.413l2.77-5.541A.462.462,0,0,0,29.438,7.048Z",
    transform: "translate(-14.943 -4.69)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.217,24.707a.462.462,0,1,0-.653.653,8.3,8.3,0,0,1,0,11.748.462.462,0,1,0,.653.653,9.22,9.22,0,0,0,0-13.053Z",
    transform: "translate(-30.245 -14.149)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.388,27.535a.462.462,0,1,0-.653.653,6.45,6.45,0,0,1,0,9.136.462.462,0,1,0,.653.653,7.373,7.373,0,0,0,0-10.442Z",
    transform: "translate(-28.722 -15.671)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.569,30.356a.462.462,0,0,0-.655.652,4.621,4.621,0,0,1,0,6.533.462.462,0,1,0,.655.652A5.545,5.545,0,0,0,49.569,30.356Z",
    transform: "translate(-27.204 -17.189)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.345,16.479v-3.4a1.383,1.383,0,0,0-2.72-.356l-3.084.984.416-1a5.541,5.541,0,1,0-4,0l.785,1.893L9.809,15.851H5.261A3.232,3.232,0,0,0,4.8,22.279v6.963a.462.462,0,0,0,.462.462H8.105a.923.923,0,0,0,.813-.485.911.911,0,0,0-.037-.937l-.388-.6V25.086H9.878a.462.462,0,0,0,.462-.462V22.487l9.286,2.955a1.383,1.383,0,0,0,2.72-.356v-3.4a2.759,2.759,0,0,0,0-5.208ZM5.723,28.78V22.316H7.57v5.5a.477.477,0,0,0,.074.249l.462.716Zm3.694-4.617H8.493V22.316h.923Zm0-2.77H5.261a2.309,2.309,0,1,1,0-4.617H9.417Zm4.313-9.226a.462.462,0,0,0-.277-.263,4.617,4.617,0,1,1,3.011,0,.462.462,0,0,0-.277.263l-1.228,2.946Zm5.846,12.287L10.34,21.517V16.65l3.759-1.2.434,1.034a.459.459,0,0,0,.85,0l.693-1.662,3.5-1.113Zm1.847.633a.462.462,0,0,1-.923,0V13.081a.462.462,0,1,1,.923,0Zm.923-4.405v-3.2a1.844,1.844,0,0,1,0,3.2Z",
    transform: "translate(-2.054 -1.998)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdeffectiveness);
export default __webpack_public_path__ + "static/media/adeffectiveness.1be7d6a4.svg";
export { ForwardRef as ReactComponent };